module.exports = __webpack_public_path__ + "img/badge-most-conversion-silver.b0f7108f.png";